import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en';
import et from './locales/et';

export const supportedLanguages = ['en', 'et'] as const;
export type SupportedLanguage = typeof supportedLanguages[number];

export const languageNames: Record<SupportedLanguage, string> = {
  en: 'English',
  et: 'Eesti',
};

export const languageFlags: Record<SupportedLanguage, string> = {
  en: '🇬🇧',
  et: '🇪🇪',
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      et: { translation: et },
    },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
